import { Injectable } from '@angular/core';
import { AlertService } from 'alert-notification';
@Injectable({ providedIn: 'root' })
export class NguAlertService {
  constructor(
    private alert: AlertService ,
  ) {}
  open(object){
    //console.log(object);
    let type = (object.type =='danger')? 'Warning':object.type;
    this.alert.setPosition('top-right');
    this.alert.push('id-01', type, object['heading'], object['msg']);  }
}


